// extracted by mini-css-extract-plugin
export var askAiIcon = "_p9-9";
export var container = "_p9-0";
export var groupSeparator = "_p9-a";
export var highlight = "_p9-4";
export var resultIcon = "_p9-5";
export var resultItem = "_p9-7";
export var resultSubtitle = "_p9-3";
export var resultTitle = "_p9-2";
export var resultsList = "_p9-1";
export var searchGroup = "_p9-6";
export var selected = "_p9-8";